
import { useState } from 'react';
import { useDashboardCore } from './admin/useDashboardCore';
import { useClientRequests } from './admin/useClientRequests';
import { useEmployeeManagement } from './admin/useEmployeeManagement';
import { useNewsletterSubscribers } from './admin/useNewsletterSubscribers';
import { useContentGeneration } from './admin/useContentGeneration';
import { useDashboardInitialization } from './admin/useDashboardInitialization';

export const useAdminDashboard = () => {
  const {
    isAdmin,
    adminStatusLoading,
    activeTab,
    setActiveTab
  } = useDashboardCore();
  
  const { 
    verifiedClients,
    onboardingRequests,
    rejectedClients,
    selectedRequest,
    isDialogOpen,
    setIsDialogOpen,
    isAddClientOpen,
    setIsAddClientOpen,
    isEditClientOpen,
    setIsEditClientOpen,
    clientToEdit,
    newStatus,
    setNewStatus,
    filterStatus: clientFilterStatus,
    setFilterStatus: setClientFilterStatus,
    isProcessing: requestProcessing,
    isLoading: requestsLoading,
    loadOnboardingRequests,
    handleRequestAction,
    updateRequestStatus,
    handleDeleteClient,
    handleToggleActive: handleToggleClientActive,
    handleAddClient,
    handleEditClient,
    updateClient
  } = useClientRequests();
  
  const {
    employees,
    isAddEmployeeOpen,
    setIsAddEmployeeOpen,
    isProcessing: employeeProcessing,
    filterStatus: employeeFilterStatus,
    setFilterStatus: setEmployeeFilterStatus,
    loadEmployees,
    handleRemoveEmployee,
    handleToggleEmployeeActive
  } = useEmployeeManagement();

  const {
    subscribers,
    isLoading: subscribersLoading,
    isProcessing: subscribersProcessing,
    isSending,
    loadSubscribers,
    handleToggleStatus,
    handleDeleteSubscriber,
    handleSendNewsletter
  } = useNewsletterSubscribers();

  const {
    generatedContent,
    blogTitle,
    blogKeywords,
    handleBlogGenerated
  } = useContentGeneration();
  
  const { handleRefresh: refreshHandler } = useDashboardInitialization({
    loadOnboardingRequests,
    loadEmployees,
    loadSubscribers
  });

  // Combined loading state
  const isLoading = adminStatusLoading || requestsLoading || subscribersLoading;
  
  // Combine isProcessing states
  const isProcessing = requestProcessing || employeeProcessing || subscribersProcessing;

  const handleRefresh = async () => {
    await refreshHandler(activeTab);
  };

  console.log('useAdminDashboard - isEditClientOpen:', isEditClientOpen, 'clientToEdit:', clientToEdit);

  return {
    isAdmin,
    isLoading,
    verifiedClients,
    onboardingRequests,
    rejectedClients,
    employees,
    subscribers,
    isSending,
    selectedRequest,
    isDialogOpen,
    setIsDialogOpen,
    isAddEmployeeOpen,
    setIsAddEmployeeOpen,
    isAddClientOpen,
    setIsAddClientOpen,
    isEditClientOpen,
    setIsEditClientOpen,
    clientToEdit,
    newStatus,
    setNewStatus,
    isProcessing,
    activeTab,
    setActiveTab,
    clientFilterStatus,
    setClientFilterStatus,
    employeeFilterStatus,
    setEmployeeFilterStatus,
    handleRequestAction,
    updateRequestStatus,
    handleRemoveEmployee,
    handleToggleEmployeeActive,
    handleToggleClientActive,
    handleRefresh,
    fetchEmployees: loadEmployees,
    handleDeleteClient,
    handleToggleStatus,
    handleDeleteSubscriber,
    handleSendNewsletter,
    handleAddClient,
    handleEditClient,
    updateClient,
    generatedContent,
    blogTitle,
    blogKeywords,
    handleBlogGenerated
  };
};
